import { render, staticRenderFns } from "./CampaignUpload.vue?vue&type=template&id=2bd40e4a&scoped=true"
import script from "./CampaignUpload.vue?vue&type=script&lang=js"
export * from "./CampaignUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd40e4a",
  null
  
)

export default component.exports